import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { BookedTrip } from '@ibe/models';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';
import { SESSION_VAR_KEY_CURRENCY, SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_LASTNAME, SESSION_VAR_KEY_MARKET, SESSION_VAR_KEY_SESSION, SESSION_VAR_KEY_USER_DATA } from '@ibe.config';
import { INDRASessionTimeoutModalComponent } from '../session-timeout-modal/session-timeout-modal.indra.component';
import { Router } from '@angular/router';
import { INDRAObservatoryService } from '@ibe.services/observatory.indra.service';
@Component({
    selector: 'app-payment-adyen-modal',
    templateUrl: './payment-adyen-modal.component.html',
    styleUrls: ['./payment-adyen-modal.component.scss']
})
export class INDRAPaymentAdyenModalComponent extends AbstractModalContentComponent implements OnInit {
    isAlive = true;
    url: string = "";
    urlSafe: SafeResourceUrl;
    showLoading = false;
    errMsg: string = "";
    hasPaymentMethodRestrictions: boolean = false;
    removedPaymentMethodRestrictions: boolean = false;

    booking_trip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
    booking_trip: BookedTrip;

    extras$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripExtras);
    extras: Array<any> = [];
    hasPartnerHotelExtra: boolean = false;

    recover_insurance$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripRecoverInsurance);
    recover_insurance;

    userInfo$: Observable<any> = this.store.select(fromStore.getUserInfo);
    userInfo: any = null;
    bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
    bookAwardFlights: boolean;
    okToDelete$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
    okToDelete = '';
    isMobile$: Observable<boolean> = this.store.select(fromStore.isScreenMobile);
    isMobile: boolean = false;
    loaded: boolean = false;

    @HostListener('window:message', ['$event'])
	onMessage(event) {
		if(event && event.data && event.data === 'sessionTimeoutModal') {
            this.modalService.close();
            this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
            this.modalService.open();
        } else if(event && event.data && event.data.redirect) {
            if(event.data.queryParams) {
                this.router.navigate([event.data.redirect, event.data.pnr, event.data.lastname], { queryParams: event.data.queryParams });
            } if(event.data.pnr){
                this.router.navigate([event.data.redirect, event.data.pnr, event.data.lastname]);
            } else {
                this.router.navigate([event.data.redirect]);
            }
        } else if(event && event.data && event.data.queryParams) {
            switch (event.data.queryParams) {
                case 'viewPurchaseSuccess':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname]);
                    break;
                case 'issueAuthorisedOK':
                case 'issueAuthorisedKO':
                    this.observatory.setData(event.data.queryParams, true);
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname]);
                    break;
                case 'viewPurchaseError':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname], { queryParams: { issue: 'PURCHASE_ERROR' } });
                    break;
                case 'viewPurchasePending':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname], { queryParams: { issue: 'PENDING' } });
                    break;
                default:
                    break;
            }
        }
	}

    constructor(
        private cdr: ChangeDetectorRef,
        protected modalService: ModalService,
        public sanitizer: DomSanitizer,
        private store: Store<fromStore.State>,
        private ibeAdminConfigService: INDRAIbeAdminConfigService,
        private router: Router,
        private observatory: INDRAObservatoryService,
    ) {
        super(modalService)
        this.TYPE= 'payment';
        this.bookAwardFlights$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.bookAwardFlights = value;
                this.updateData({ bookAwardFlights: this.bookAwardFlights });
            });
    }

    ngOnInit() {
        const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue('externalURLs.AdyenPaymentUrl');
        this.showLoading = true;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlIbeAdmin);
        this.booking_trip$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(trip => {
                if (trip) {
                    this.booking_trip = trip;

                    if (trip.insurance) {
                        this.hasPaymentMethodRestrictions = true;
                    } else {
                        this.hasPaymentMethodRestrictions = false;
                    }
                    this.updateData({ hasPaymentMethodRestrictions: this.hasPaymentMethodRestrictions });
                }
            });

        this.extras$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.extras = value;
                    const hotels = this.extras.find(extra => extra.type === 'hotel');
                    this.hasPartnerHotelExtra = (hotels && hotels.data && hotels.data.length > 0) ? true : false;
                } else {
                    this.hasPartnerHotelExtra = false;
                }
                this.updateData({ hasPartnerHotelExtra: this.hasPartnerHotelExtra });
            });
        this.recover_insurance$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(insurance => {
                if (insurance && insurance.length) {
                    this.recover_insurance = insurance;
                    this.removedPaymentMethodRestrictions = true;
                } else {
                    this.recover_insurance = null;
                    this.removedPaymentMethodRestrictions = false;
                }
                this.updateData({ removedPaymentMethodRestrictions: this.removedPaymentMethodRestrictions });
            });
        this.userInfo$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(values => {
                this.userInfo = values;
                this.updateData({ userInfo: this.userInfo });
            });

        this.isMobile$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.isMobile = value;
                this.updateData({ isMobile: this.isMobile });
            });

        this.okToDelete$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.okToDelete = value;
                    this.updateData({ okToDelete: this.okToDelete });
                }
            });
    }

    INDRA_close() {
        this.closeModal();
    }

    onLoad() {
        let iframe = document.getElementById('adyen-iframe') as HTMLIFrameElement;
        this.loaded = true;
        const paymentData = Object.assign(this.data[0], {
            hasPaymentMethodRestrictions: this.hasPaymentMethodRestrictions,
            removedPaymentMethodRestrictions: this.removedPaymentMethodRestrictions,
            hasPartnerHotelExtra: this.hasPartnerHotelExtra,
            bookAwardFlights: this.bookAwardFlights,
            userInfo: this.userInfo,
            isMobile: this.isMobile,
            okToDelete: this.okToDelete,
            sessionStorageInfo: {
                language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE),
                market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
                currency: sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY),
                decimals: sessionStorage.getItem('decimals'),
                token: sessionStorage.getItem(SESSION_VAR_KEY_SESSION),
                lastname: sessionStorage.getItem(SESSION_VAR_KEY_LASTNAME),
                userData: sessionStorage.getItem(SESSION_VAR_KEY_USER_DATA)
            },
            type: 'ibetpfront'
        })
        iframe.contentWindow.postMessage(paymentData, '*');
        this.showLoading = false;
    }

    private updateData(data) {
        data.type = 'ibetpfront';
        if(this.loaded) {
            let iframe = document.getElementById('adyen-iframe') as HTMLIFrameElement;
            iframe.contentWindow.postMessage(data, '*');
        }
    }

    ngAfterContentChecked(): void {
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.isAlive = false;
    }

}
